module.exports = __webpack_public_path__ + "static/media/rental-income-other.de608e65.svg";